import React from 'react';
import axios from 'axios';
import AuthenticationStore from '../api/AuthenticationStore.js';
import { MessageAPI } from './PageMessage.jsx';
import WebAPI from '../api/WebAPI.js';
class Logout extends React.Component {
    constructor(props) {
        super(props);
        this.redirectToLogin = this.redirectToLogin.bind(this);
    }
    componentDidMount() {
        this.redirectToLogin();
    }
    redirectToLogin() {
		WebAPI.getData("/session/logout?type=full").then(res => {
            var logoutURL = res.data;
            window.location.href = logoutURL;
        }
        ).catch(err => {window.location.href = window.env.LOGINAPP_URL;})
        
    }
    render(props) {
        return (
            <div className="">
                <div className="d-sm-none d-md-block col-md-2"></div>
                <div className="col-sm-12 col-md-8">
                    <div className="oam-password-detail-tips">
                        <div className="row">
                            <div className="row row-equal">
                                <h1>Please wait, system is logging you out......</h1>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="d-sm-none d-md-block col-md-2"></div>
            </div>
        );
    }
}

export default Logout;